import { EmptystateWebhooksColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";

const WebhookDeliveriesEmpty = () => {
  return (
    <EmptyState
      title="No deliveries yet"
      icon={EmptystateWebhooksColored}
      caption="Once this webhook is triggered, its delivery attempts will show up here."
    />
  );
};

export default WebhookDeliveriesEmpty;
